import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const triggerService = {
  _main_url: process.env.REACT_APP_AUTH_API_URL,

  GetTriggersList(agentId, fetch) {
    const [data, setsData] = useState({
      triggers: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getTriggers(agentId))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      trigger_data: data,
    };
  },

  async getTriggers(agentId) {
    return await Fetch.get(`${this._main_url}/triggers/list?agent_id=${agentId}`);
  },
};

export default triggerService;
